import React, { useEffect } from "react";
import { UsernameStyleInterface } from "../../../../store/mine_craft/usernameStylesSlice";

import { Button, Form, Input, InputNumber } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import { usernameStyleStyles } from "../../../../helpers/TextHelpers";

interface propsInterface {
  params?: UsernameStyleInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const text_gradient_angle = Form.useWatch('text_gradient_angle', form);
  const text_color_start = Form.useWatch('text_color_start', form);
  const text_color_end = Form.useWatch('text_color_end', form);
  const stroke_color_end = Form.useWatch('stroke_color_end', form);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-mb-20 v-mt-20'>
        <div
          style={
            usernameStyleStyles({
              text_gradient_angle: text_gradient_angle,
              text_color_start: text_color_start,
              text_color_end: text_color_end,
              stroke_color_end: stroke_color_end,
            })
          }
          className='v-username-style-preview'
        >
          User Nickname
        </div>
      </div>

      <Form.Item name='text_gradient_angle' label='Text Gradient Angle'>
        <InputNumber
          min={0}
          max={360}
          placeholder='Angle in degrees'
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item name='text_color_start' label='Text Color Start'>
        <Input placeholder='Start color (e.g. #FFFFFF)' />
      </Form.Item>

      <Form.Item name='text_color_end' label='Text Color End'>
        <Input placeholder='End color (e.g. #000000)' />
      </Form.Item>

      <Form.Item name='stroke_color_start' label='Stroke Color Start'>
        <Input placeholder='Start color (e.g. #FFFFFF)' />
      </Form.Item>

      <Form.Item name='stroke_color_end' label='Stroke Color End'>
        <Input placeholder='End color (e.g. #000000)' />
      </Form.Item>

      <Form.Item name='stroke_gradient_angle' label='Stroke Gradient Angle'>
        <InputNumber
          min={0}
          max={360}
          placeholder='Angle in degrees'
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item name='stroke_width' label='Stroke Width'>
        <InputNumber
          min={0}
          step={1}
          placeholder='Width in px'
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item name='coins' label='Coins'>
        <InputNumber
          min={0}
          step={5}
          placeholder='0'
          prefix={<DollarOutlined />}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
